import { Eye } from 'lucide-react'
import { Button } from '@klear/ui/components/button'

export function DocumentViewButton({
  name,
  unavailableReason,
  onView
}: {
  name: string
  unavailableReason: string | null
  onView: () => void
}) {
  return (
    <span title={unavailableReason ?? 'View'} className="inline-flex">
      <Button variant="ghost" className="h-8 w-8 p-0" onClick={onView} disabled={unavailableReason !== null}>
        <Eye className="h-4 w-4" />
        <span className="sr-only">View {name}</span>
      </Button>
    </span>
  )
}
